import { KanbanState, KanbanStateCourtyard } from '..'
import { BookingStatusEnum } from '../../../../schemas/enum.schemas'

export const initialData: KanbanState = {
  columns: {
    [BookingStatusEnum.enum.PENDING]: {
      id: BookingStatusEnum.enum.PENDING,
      title: 'Aguardando aceite',
      bookings: [],
    },
    [BookingStatusEnum.enum.INPROGRESS]: {
      id: BookingStatusEnum.enum.INPROGRESS,
      title: 'Em andamento',
      bookings: [],
    },
    [BookingStatusEnum.enum.FINISHED]: {
      id: BookingStatusEnum.enum.FINISHED,
      title: 'Finalizadas',
      bookings: [],
    },
  },
  columnOrder: [
    BookingStatusEnum.enum.PENDING,
    BookingStatusEnum.enum.INPROGRESS,
    BookingStatusEnum.enum.FINISHED,
  ],
}

export const initialDataCourtyard: KanbanStateCourtyard = {
  columns: {
    [BookingStatusEnum.enum.PENDING]: {
      id: BookingStatusEnum.enum.PENDING,
      title: 'Pendente',
      courtyards: [],
    },
    [BookingStatusEnum.enum.INPROGRESS]: {
      id: BookingStatusEnum.enum.INPROGRESS,
      title: 'Em andamento',
      courtyards: [],
    },
    [BookingStatusEnum.enum.FINISHED]: {
      id: BookingStatusEnum.enum.FINISHED,
      title: 'Finalizadas',
      courtyards: [],
    },
  },
  columnOrder: [
    BookingStatusEnum.enum.PENDING,
    BookingStatusEnum.enum.INPROGRESS,
    BookingStatusEnum.enum.FINISHED,
  ],
}
